import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import "../styles/OrderAndReview.css";
import { FiPackage, FiInbox, FiChevronDown, FiChevronUp, FiStar } from "react-icons/fi";

export default function OrderAndReview() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [message, setMessage] = useState("");
    const [orders, setOrders] = useState([]);
    const [filterStatus, setFilterStatus] = useState("All");
    const [expandedOrder, setExpandedOrder] = useState(null);
    const [cancelingOrder, setCancelingOrder] = useState(null);
    const [cancelReason, setCancelReason] = useState("");
    const [submittingCancel, setSubmittingCancel] = useState(false);




    useEffect(() => {
        fetch(`https://biosurgebackend-1.onrender.com/api/orders/user/${id}`)
            .then((res) => res.json())
            .then((data) => {
                const arr = Array.isArray(data) ? data : data.orders || [];
                // Ensure every item has reviewSubmitted flag
                const normalized = arr.map((order) => {
                    if (Array.isArray(order.items)) {
                        const itemsWithFlag = order.items.map((item) => ({
                            ...item,
                            reviewSubmitted: item.reviewSubmitted || false,
                        }));
                        return { ...order, items: itemsWithFlag };
                    }
                    return order;
                });
                setOrders(normalized);
            })
            .catch((err) => console.error("Fetch orders error:", err));
    }, [id]);


    const handleCancelOrder = async (orderId) => {
        // Confirmation alert
        const confirmCancel = window.confirm("Are you sure you want to cancel this order?");
        if (!confirmCancel) return;

        setSubmittingCancel(true);

        try {
            const res = await fetch(`https://biosurgebackend-1.onrender.com/api/orders/${orderId}/tracking`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ status: "Cancelled" }), // message removed
            });

            if (!res.ok) throw new Error("Failed to cancel order");

            const updatedOrder = await res.json();

            setOrders((prevOrders) =>
                prevOrders.map((o) => (o._id === orderId ? updatedOrder : o))
            );

            setCancelingOrder(null);
        } catch (err) {
            console.error(err);
            alert("Could not cancel order.");
        } finally {
            setSubmittingCancel(false);
        }
    };




    const handleFilterClick = (status) => {
        setFilterStatus(status);
        setExpandedOrder(null);
    };


    const filteredOrders = orders.filter((order) => {
        if (filterStatus === "All") return true;
        return order.status === filterStatus;
    });

    return (
        <div className="profile-container">
            <section className="orders-section">
                <div className="dashboard-card">
                    <div className="orders-header">
                        <h2 style={{ color: 'whitesmoke' }}><FiPackage /> Order History</h2>
                        <div className="status-filter">
                            {["All", "Processing", "Shipped", "Delivered"].map((status) => (
                                <button
                                    key={status}
                                    className={`filter-btn ${filterStatus === status ? "active" : ""}`}
                                    onClick={() => handleFilterClick(status)}
                                >
                                    {status}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="orders-list">
                        {filteredOrders.length === 0 ? (
                            <div className="empty-state">
                                <div className="empty-icon"><FiInbox /></div>
                                <p>No orders with this status.</p>
                            </div>
                        ) : (
                            filteredOrders.map((order, idx) => (
                                <div
                                    className={`order-card ${order.status.toLowerCase() || "processing"
                                        }`}
                                    key={order._id || idx}
                                >
                                    {/* Order Header */}
                                    <div className="order-header">
                                        <div className="order-meta">
                                            <span className="order-number">ORDER #{idx + 1}</span>
                                            <span className="order-date">
                                                {new Date(order.createdAt).toLocaleDateString()}
                                            </span>
                                        </div>
                                        <div
                                            className={`status-badge ${order.status.toLowerCase()
                                                }`}
                                        >
                                            {order.status}
                                        </div>
                                    </div>

                                    {/* Order Body (Thumbnail + Summary) */}
                                    <div className="order-body">
                                        <div className="product-preview">
                                            {order.items.slice(0, 3).map((item, i) => (
                                                <div className="product-thumb" key={i}>
                                                    {item.productId && (
                                                        <img
                                                            src={
                                                                item.productId.images?.[0]?.startsWith('http')
                                                                    ? item.productId.images[0]
                                                                    : item.productId.image?.startsWith('http')
                                                                        ? item.productId.image
                                                                        : `https://biosurgebackend-1.onrender.com/ServiceProduct/${item.productId.image || ''}`
                                                            }
                                                            alt={item.productId.title || 'Product'}
                                                            className="thumb-image"
                                                            onError={(e) => (e.target.src = '/fallback.png')}
                                                            style={{ height: '80px', width: '80px', objectFit: 'cover' }}
                                                        />
                                                    )}

                                                </div>
                                            ))}
                                        </div>

                                        <div className="order-summary">
                                            <div className="summary-item">
                                                <span>Items: </span>
                                                <span>{order.items.length}</span>
                                            </div>
                                            <div className="summary-item">
                                                <span>Product: </span>
                                                <span>
                                                    {order.items[0]?.productId?.title
                                                        ? order.items[0].productId.title
                                                        : "—"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Order Footer (Details Toggle + Review Button) */}

                                    <div className="order-footer">
                                        <button className="detail-btn" onClick={() =>
                                            setExpandedOrder(
                                                expandedOrder === order._id ? null : order._id
                                            )
                                        }>
                                            {expandedOrder === order._id ? <FiChevronUp /> : <FiChevronDown />}
                                            {expandedOrder === order._id ? " Close Details" : " View Details"}
                                        </button>
                                        {order.status === "Delivered" && (
                                            <button className="review-btn" ><FiStar /> Leave Review</button>
                                        )}
                                        {/* {order.status !== "Delivered" && order.status !== "Cancelled" && cancelingOrder !== order._id && (
                                            <button
                                                className="cancel-btn"
                                                onClick={() => setCancelingOrder(order._id)}
                                            >
                                                Cancel Order
                                            </button>
                                        )} */}

                                        {cancelingOrder === order._id && (
                                            <div className="cancel-reason-box">
                                                <div style={{ marginTop: "0.5rem" }}>
                                                    <button
                                                        onClick={() => handleCancelOrder(order._id)}
                                                        disabled={submittingCancel}
                                                    >
                                                        {submittingCancel ? "Cancelling…" : "Confirm Cancel"}
                                                    </button>
                                                    <button
                                                        onClick={() => setCancelingOrder(null)}
                                                        style={{ marginLeft: "0.5rem" }}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>




                                    {/* Expanded Order Details */}
                                    {expandedOrder === order._id && (
                                        <div className="order-details">
                                            {Array.isArray(order.items) &&
                                                order.items.length > 0 ? (
                                                <ul className="item-list-expanded">
                                                    {order.items.map((it, j) => {
                                                        const product = it.productId;
                                                        const title =
                                                            product?.title || "(Unknown Product)";
                                                        const alreadyReviewed = Boolean(
                                                            it.reviewSubmitted
                                                        );

                                                        return (
                                                            <li className="item-row-expanded" key={j}>
                                                                <div className="item-main-expanded">
                                                                    <span className="item-name-expanded">
                                                                        {title}
                                                                    </span><br />
                                                                    <span className="item-details-expanded">
                                                                        Qty: {it.qty}<br />
                                                                        Size: {it.size}

                                                                    </span>
                                                                </div>

                                                                {order.status === "Delivered" &&
                                                                    !alreadyReviewed && (
                                                                        <ReviewForm
                                                                            userId={id}
                                                                            productId={product?._id}
                                                                            orderItemIndex={j}
                                                                            orderId={order._id}
                                                                            onReviewSubmitted={() => {
                                                                                setOrders((prevOrders) =>
                                                                                    prevOrders.map((o) => {
                                                                                        if (o._id !== order._id) return o;
                                                                                        const newItems = o.items.map(
                                                                                            (item, k) => {
                                                                                                if (k !== j) return item;
                                                                                                return {
                                                                                                    ...item,
                                                                                                    reviewSubmitted: true,
                                                                                                };
                                                                                            }
                                                                                        );
                                                                                        return { ...o, items: newItems };
                                                                                    })
                                                                                );
                                                                            }}
                                                                        />
                                                                    )}

                                                                {order.status === "Delivered" &&
                                                                    alreadyReviewed && (
                                                                        <p className="review-thankyou-expanded">
                                                                            Thanks for your review!
                                                                        </p>
                                                                    )}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            ) : (
                                                <p className="no-items-expanded">
                                                    No items in this order.
                                                </p>
                                            )}

                                            {Array.isArray(order.tracking) &&
                                                order.tracking.length > 0 && (
                                                    <TrackingTimeline events={order.tracking} />
                                                )}

                                            <p className="detail-text-expanded">
                                                <strong>Order ID:</strong> {order._id} <br />
                                                <strong>Courier:</strong> {order.courierPartner || "—"}{" "}
                                                <br />
                                                <strong>Tracking #:</strong>{" "}
                                                {order.trackingNumber || "—"} <br />
                                                {order.shipping && (
                                                    <>
                                                        <strong>Ship To:</strong> {order.shipping.address},{" "}
                                                        {order.shipping.city}, {order.shipping.country} (PIN{" "}
                                                        {order.shipping.postalCode}) <br />
                                                    </>
                                                )}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
}

// ------------------------------------------------------
// ReviewForm Component
// ------------------------------------------------------
function ReviewForm({
    userId,
    productId,
    orderId,
    orderItemIndex,
    onReviewSubmitted,
}) {
    const [rating, setRating] = useState(5);
    const [comment, setComment] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState("");

    const handleSubmitReview = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError("");

        try {
            const res = await fetch(
                `https://biosurgebackend-1.onrender.com/api/reviews/${productId}/reviews`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        userId,
                        rating,
                        comment,
                        orderId,
                        orderItemIndex,
                    }),
                }
            );
            if (!res.ok) throw new Error("Failed to submit review.");
            await res.json();
            onReviewSubmitted();
        } catch (err) {
            console.error(err);
            setError("Could not submit review.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form className="review-form-expanded" onSubmit={handleSubmitReview}>
            <div className="review-group-expanded">
                <label className="review-label">Rating:</label>
                <select
                    value={rating}
                    onChange={(e) => setRating(Number(e.target.value))}
                    disabled={submitting}
                    className="review-select-expanded"
                >
                    <option value={5}>★★★★★</option>
                    <option value={4}>★★★★☆</option>
                    <option value={3}>★★★☆☆</option>
                    <option value={2}>★★☆☆☆</option>
                    <option value={1}>★☆☆☆☆</option>
                </select>
            </div>

            <div className="review-group-expanded">
                <label className="review-label">Comment:</label>
                <textarea
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Write your review…"
                    rows={3}
                    disabled={submitting}
                    className="review-textarea-expanded"
                />
            </div>

            {error && <p className="review-error-expanded">{error}</p>}

            <button
                type="submit"
                className="btn-submit-review-expanded"
                disabled={submitting}
            >
                {submitting ? "Submitting…" : "Submit Review"}
            </button>
        </form>
    );
}

// ------------------------------------------------------
// TrackingTimeline Component
// ------------------------------------------------------
function TrackingTimeline({ events }) {
    const formatTimestamp = (isoString) => {
        const d = new Date(isoString);

        const day = d.getDate();
        const suffix =
            day % 10 === 1 && day !== 11
                ? "st"
                : day % 10 === 2 && day !== 12
                    ? "nd"
                    : day % 10 === 3 && day !== 13
                        ? "rd"
                        : "th";
        const dayWithSuffix = `${day}${suffix}`;

        const monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        const month = monthNames[d.getMonth()];

        const yearShort = String(d.getFullYear()).slice(-2);

        let hours = d.getHours();
        const minutes = d.getMinutes().toString().padStart(2, "0");
        const ampm = hours >= 12 ? "pm" : "am";
        hours = hours % 12 || 12;
        const timeString = `${hours}:${minutes}${ampm}`;

        const weekday = d.toLocaleDateString("en-US", { weekday: "short" });
        return `${weekday}, ${dayWithSuffix} ${month} ’${yearShort} – ${timeString}`;
    };

    return (
        <div className="timeline-expanded">
            {events.map((ev, i) => (
                <div className="timeline-item-expanded" key={i}>
                    <span className="timeline-dot-expanded" />
                    <div className="timeline-content-expanded">
                        <h4 className="timeline-status-expanded">{ev.status}</h4>
                        <p className="timeline-message-expanded">
                            {ev.message || "No message available"}
                        </p>
                        <p className="timeline-timestamp-expanded">
                            {formatTimestamp(ev.timestamp)}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    );
}
